export default __webpack_public_path__ + "img/email-header.c7bddcd18c00df98a67497e291a28814.jpg";